import {Pipe, PipeTransform} from "@angular/core";

@Pipe({name: "checkForFullWidth"})
export class CheckForFullWidth implements PipeTransform {
  constructor() {
  }
  transform(value: any) {

    let allowNotice = true;
    if(typeof value != "undefined" && value!=null) {
      value.forEach(element => {
        if (element.FieldName == "Notices" && typeof element.NoticeMode != "undefined" && element.NoticeMode.includes('Visible')) {
          allowNotice = false;
        }
      });
    }

    return allowNotice;
  }
}




// WEBPACK FOOTER //
// ./src/pipes/checkForFullWidth.ts